import {
  SearchSuggestionsList,
  SearchSuggestionsWrapper,
  Suggestionitem,
  currentSuggestionItem
} from './SearchSuggestionsStyles';
import { getHighlightedText } from '../SearchBoxHandler';
import { SuggestionType } from '../SearchTypes';

type SearchSuggetionPropType = {
  searchSuggestions: Array<SuggestionType>;
  queryString: string;
  currentIndex: number;
  searchByText: (searchText: string, e: React.MouseEvent) => void;
};

const SearchSuggestions = (props: SearchSuggetionPropType) => {
  const { searchSuggestions, queryString, searchByText, currentIndex } = props;
  const searchSuggestionsData = searchSuggestions.map(
    (row: SuggestionType, index: number) => {
      const suggestedSearchList = row.in
        ? `${getHighlightedText(queryString, row.text)} in ${row.in}`
        : getHighlightedText(queryString, row.text);
      return (
        <SearchSuggestionsList
          css={currentIndex === index ? currentSuggestionItem : ''}
          key={index}
          id={row.text}>
          <Suggestionitem
            data-testid="search-suggestion"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: suggestedSearchList }}
            onClick={(e) => searchByText(row.text, e)}></Suggestionitem>
        </SearchSuggestionsList>
      );
    }
  );

  return (
    <SearchSuggestionsWrapper data-testid="search-suggestions-container">
      {searchSuggestionsData}
    </SearchSuggestionsWrapper>
  );
};

export default SearchSuggestions;
